module.exports = __webpack_public_path__ + "static/media/arrow2.78e24bbe.svg";